var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.msg
    ? _c("div", { staticClass: "ui negative message appMessage hidden" }, [
        _vm.closable
          ? _c("i", { staticClass: "close icon", on: { click: _vm.hide } })
          : _vm._e(),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.msg))]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }